import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase";
import Skeleton from "react-loading-skeleton";
import { useNavigate, Link } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import Offerimg from "../../Images/Serviceimg/offerimg.png";
import "../Bathroom/Bathroom.css";
import "react-loading-skeleton/dist/skeleton.css";
import { Rate, message } from "antd";
import Loading1 from "../../Components/Loading/Loading1";
import VideoUrl from "../../videos/KitchenCleaning.mp4";
import HomeNav from "../../Components/Navbar/NewNavbar";
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import KitchenCleaningInfo from "./KitchenInfo";
import DetailsModal from '../../Components/DetailsModal/DetailsModal'
import DiscountIcon from '@mui/icons-material/Discount';
import EmptyCartImg from "../../Images/Serviceimg/abandoned-cart.png";


const Kitchen = () => {
  const [services, setServices] = useState([]);
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [videoUrl, setVideoUrl] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);  // Track the selected service for details modal

  const navigate = useNavigate();

  useEffect(() => {
    const fetchServices = async () => {
      const servicesCollectionRef = collection(db, "services", "kitchen", "0");
      const querySnapshot = await getDocs(servicesCollectionRef);
      let servicesList = [];
      querySnapshot.forEach((doc) => {
        servicesList.push({ id: doc.id, ...doc.data() });
      });
      setServices(servicesList);
      setLoading(false);
    };

    const fetchVideoUrl = async () => {
      const storage = getStorage();
      const videoRef = ref(storage, "serviceVideos/KitchenVideo/CleaningVideo1.mp4");
      try {
        const url = await getDownloadURL(videoRef);
        setVideoUrl(url);
      } catch (error) {
        console.error("Error fetching video URL:", error);
      }
    };

    fetchServices();
    fetchVideoUrl();
    setCart(JSON.parse(localStorage.getItem("cart")) || []);
  }, []);

  const GoToCart = () => {
    navigate("/cart");
  };

  const addToCart = (service) => {
    let cartItems = [...cart];
    const existingIndex = cartItems.findIndex((item) => item.id === service.id);

    if (existingIndex > -1) {
      cartItems[existingIndex].qty += 1;
    } else {
      service.qty = 1;
      cartItems.push(service);
    }

    localStorage.setItem("cart", JSON.stringify(cartItems));
    message.success("Item Added in Cart");
    setCart(cartItems);
  };

  const removeFromCart = (index) => {
    let cartItems = [...cart];
    cartItems.splice(index, 1);
    localStorage.setItem("cart", JSON.stringify(cartItems));
    setCart(cartItems);
  };

  const incrementQty = (index) => {
    let cartItems = [...cart];
    cartItems[index].qty += 1;
    localStorage.setItem("cart", JSON.stringify(cartItems));
    setCart(cartItems);
  };

  const decrementQty = (index) => {
    let cartItems = [...cart];
    if (cartItems[index].qty > 1) {
      cartItems[index].qty -= 1;
    } else {
      cartItems.splice(index, 1);
    }
    localStorage.setItem("cart", JSON.stringify(cartItems));
    setCart(cartItems);
  };

  const openModal = (service) => {
    setSelectedService(service);  // Set the selected service
    setIsOpen(true);  // Open the modal
  };

  const closeModal = () => {
    setIsOpen(false);  // Close the modal
    setSelectedService(null);  // Clear the selected service
  };
  const calculateTotalPrice = () => {
    return cart.reduce((total, item) => total + item.discountedPrice * item.qty, 0);
  };
  const increaseQty = (index) => {
    const updatedCart = [...cart];
    updatedCart[index].qty += 1;
    setCart(updatedCart);
  };

  const decreaseQty = (index) => {
    const updatedCart = [...cart];
    if (updatedCart[index].qty > 1) {
      updatedCart[index].qty -= 1;
    } else {
      updatedCart.splice(index, 1); // Remove item if quantity is 0
    }
    setCart(updatedCart);
  };

  if (loading) {
    return <Loading1 />;
  }

  const skeletonProps = {
    baseColor: "#ddd",
    highlightColor: "#eee",
  };

  return (
    <>
      <HomeNav />
      <div className="container my-5">
        <div className="row">
          <div className="minicart-video">
            <div className="minicart-container1">
              <h1 className="display-4">Kitchen Cleaning</h1>
              <h3>
                Astra Clean offers thorough kitchen cleaning services to keep your
                cooking space pristine and sanitary. Our skilled team tackles
                grease, stains, and food residues, ensuring every surface is
                spotless and safe for meal preparation.
              </h3>
              <div className="service-rating">

                <div className="ratings-service">
                  <div className="rating-title">Average Rating</div>
                  <div className="rating-descreption">
                    <span style={{ fontSize: "25px", fontWeight: "500" }}>4.7</span>
                    <Rate allowHalf defaultValue={4.7} className="ratingcolor" disabled />
                  </div>
                  <div className="rating-year">Average rating on this year</div>
                </div>
              </div>
            </div>
            <div className="minicart-container2">
              <div className="minicart-container2-subcontainer">
                <div className="minicart-container2-video">
                  {loading ? (
                    <div className="video-skeleton">
                      <Skeleton height={500} width={800} {...skeletonProps} />
                    </div>
                  ) : (
                    <video src={VideoUrl} autoPlay loop muted></video>
                  )}
                </div>
                <div className="minicart-container2-carts">
                  <div className="other-services">
                    {services.map((service) => (
                      <div key={service.id} className="col-md-4 my-3">
                        <div className="card service-card">
                          <div className="card-service-card-container">
                            <img src={service.img} className="card-img-top" alt={service.name} />
                            <div className="card-body">
                              <h5 className="card-title" style={{ color: 'black' }}>{service.name}</h5>
                              <ul className="card-text">
                                {(Array.isArray(service.description)
                                  ? service.description
                                  : [service.description]
                                ).map((point, index) => (
                                  <li key={index}>
                                    {point.length > 50 ? `${point.substring(0, 50)}...` : point}
                                  </li>
                                ))}
                              </ul>

                              <div className="rating-container">
                                <span style={{ fontSize: '20px', fontWeight: '600', marginRight: '7px' }}>{service.rating}</span>
                                <Box component="div" mt={0.8}>
                                  <Rating
                                    name="rating"
                                    value={service.rating}
                                    precision={0.1}
                                    size="medium"
                                    readOnly
                                  />
                                </Box>
                              </div>
                            </div>
                          </div>
                          <div className="card-footer">
                            <div className="pricesofservices">
                              <span className="originalprice">Rs.{service.originalPrice}</span>
                              <span className="price">Rs.{service.discountedPrice}</span>
                            </div>
                            <div className="btn-cartpage">
                              <button className="btn btn-add" onClick={() => addToCart(service)}>
                                Add to Cart
                              </button>
                              <button className="btn btn-add" onClick={() => openModal(service)}>
                                View Details
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="offers-deiscount">
                    <div className="cart-services-page">

                      {cart.length > 0 ? (
                        <>
                          <div className="cart-name" style={{ fontWeight: 400 }}>Cart</div>
                          {/* <p>Total Items: {cart.length}</p> */}
                          <ul>
                            {cart.map((item, index) => (
                              <li key={index}>
                                <span style={{ fontWeight: 400, fontSize: '0.8rem' }} className="service-price-span">{item.name}</span>
                                <div className="services-cart-btns">
                                  <button onClick={() => increaseQty(index)}>+</button>
                                  <span>{item.qty}</span>
                                  <button onClick={() => decreaseQty(index)}>-</button>
                                </div>
                                Rs.{item.discountedPrice}
                              </li>
                            ))}
                          </ul>
                          <div className="service-cart-navigate">
                            <p style={{ color: 'white' }}>Total Price: Rs.{calculateTotalPrice()}</p>
                            <button onClick={() => navigate('/cart')}>View Cart</button>
                          </div>
                        </>
                      ) : (
                        <div className="empty-cart">
                          <img src={EmptyCartImg} alt="Empty Cart" />
                          <p>No items in your cart</p>
                        </div>
                      )}
                    </div>

                    <div className="offer-card">
                      <div className="offer-icon">
                        <span className="icon"><DiscountIcon style={{ color: 'green' }} /></span>
                      </div>
                      <div className="offer-details">
                        <h4 className="offer-title">Assured reward from CRED</h4>
                        <p className="offer-subtitle">On all online payments</p>
                        <Link href="#" className="more-offers">View More Offers ▼</Link>
                        <div className="offers-discount-offers"></div>
                      </div>
                    </div>
                    <div className="services-guidlines"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="about-services">
            <KitchenCleaningInfo />
          </div>
        </div>
      </div>
      <Footer />
      <DetailsModal isOpen={isOpen} onClose={closeModal} service={selectedService} /> {/* Pass service data to modal */}
    </>
  );
};

export default Kitchen;
